import { createFileRoute } from '@tanstack/react-router';
import { AuthGate } from '@/features/session';

/** Layout of every route that needs a back-office session. */
export const Route = createFileRoute('/_auth')({
  component: AuthGate,
});
